/*@ngInject*/
const FieldRuleBuilderController = function ($element, $rootScope, $scope, $timeout, formViewerConstant, localization, ruleUtil, uiFormTemplateModel, umStudioConstant) {
    var timeoutList = [];

    $element.addClass('fieldRuleBuilder');

    this.hideTheseFields = '';
    this.deleteTheseFields = '';
    this.hide = false;
    this.uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
    this.fieldsInRule = [];

    localization.getTranslations().then(function (translations) {
        this.hideTheseFields = _.get(translations, 'fieldRuleBuilder.hideTheseFields');
        this.deleteTheseFields = _.get(translations, 'fieldRuleBuilder.deleteTheseFields');

        this.getHideOrDeleteLabel = function () {
            if (this.hide) {
                return this.hideTheseFields;
            } else {
                return this.deleteTheseFields;
            }
        };
    }.bind(this));

    this.isDescriptionSet = function () {
        return !_.isEmpty(this.fieldRule.description);
    }

    this.$onInit = function () {
        this.initialize();
    };

    this.$onChanges = function () {
        this.initialize();
    };

    this.initialize = function () {
        this.setUpHideOrDelete();
        if (this.focusOnRuleName) {
            timeoutList.push($timeout(function () {
                $scope.$broadcast(umStudioConstant.event.FOCUS_ON_RULE_NAME);
            }, 0));
        }
    };

    this.setUpHideOrDelete = function () {
        var fieldTemplate;

        this.fieldsInRule = [];
        this.fieldsInRule = _.filter(this.uiFormTemplate.formTemplate.fieldTemplates, function (fieldTemplate) {
            return fieldTemplate.triggerRuleName === ruleUtil.getRuleNameSubstring(this.fieldRule);
        }.bind(this));
        if (!_.isEmpty(this.fieldsInRule)) {
            fieldTemplate = this.fieldsInRule[0];
            this.hide = fieldTemplate.untriggerBehavior;
        }
    };

    this.findUiField = function (fieldTemplateId) {
        var foundUiField;
        _.each(this.uiFormTemplate.sections, function (section) {
            _.each(section.rows, function (row) {
                _.each(row.fields, function (field) {
                    if (field.fieldTemplate.id === fieldTemplateId) {
                        foundUiField = field
                        return false;
                    }
                });
            });
        });

        return foundUiField;
    };

    this.updateFieldsInRule = function (untriggerBehavior, conditionalFieldsNotInRule) {

        _.each(this.fieldsInRule, function (fieldInRule) {
            fieldInRule.untriggerBehavior = untriggerBehavior;
            this.updateUiFieldFieldTemplate(fieldInRule);
        }.bind(this));

        _.each(conditionalFieldsNotInRule, function (field) {
            this.updateUiFieldFieldTemplate(field);
        }.bind(this));

        $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    };

    this.updateUiFieldFieldTemplate = function (fieldTemplate) {
        var uiField = this.findUiField(fieldTemplate.id);
        if (!_.isNil(uiField)) {
            uiField.fieldTemplate = fieldTemplate;
        }
    };

    this.hideFields = function () {
        this.hide = true;
        this.updateFieldsInRule(1);
    };

    this.deleteFields = function () {
        this.hide = false;
        this.updateFieldsInRule(0);
    };

    this.doFieldsInRuleUpdated = function (conditionalFieldsNotInRule) {
        var untriggerBehavior = this.hide ? 1 : 0;
        this.updateFieldsInRule(untriggerBehavior, conditionalFieldsNotInRule);
    };

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('ums.configuration')
    .controller('fieldRuleBuilderController', FieldRuleBuilderController);
